import React from 'react';
import { Button } from 'react-bootstrap';
import BzmIcon from 'components/icons/BzmIcon';
import i18n from 'i18n';

interface DownloadBtnProps {
  onDownload: () => void;
}

const DownloadBtn = (props: DownloadBtnProps) => {
  return (
    <Button
      onClick={props.onDownload}
      className={'btn btn-secondary btn-sm float-right mr-2 position-relative'}
      style={{ bottom: '6px' }}
    >
      <BzmIcon variant={'icon-bzm-download'} className={'icon-xs mr-2'} />
      <span className={'position-relative'} style={{ bottom: '2px' }}>
        {i18n.t('common:actions.download')}
      </span>
    </Button>
  );
};

export default DownloadBtn;
